import React from "react";
import { NavWrap } from "../ShopForTyres";
import download from "../../assets/download.svg";
const Warranties = () => {
  return (
    <NavWrap>
      <div className="marketing">
        <h3>Warrenties</h3>
        <ul className="download-items">
          <h2>Warranty Information</h2>
          <li>
            <img src={download} alt="download" width={20} height={12} />
            <strong>
              <span>Limited Warranty Quick Reference Guide – </span> - Passenger
              and Light Truck replacement tyres purchased after October 1, 2020.
            </strong>
          </li>
        </ul>
        <br />
        <ul className="download-items">
          <h2>Download Center</h2>
          <li>
            <img src={download} alt="download" width={20} height={12} />
            <strong>
              <span>Limited Warranty Manual</span>
            </strong>
          </li>
        </ul>
      </div>
    </NavWrap>
  );
};

export default Warranties;
